import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, Optional, PLATFORM_ID } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { RESPONSE } from '@nguniversal/express-engine/tokens';
import { Response } from 'express';

@Injectable({
  providedIn: 'root',
})
export class RedirectService {
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    @Optional() @Inject(RESPONSE) private response: Response,
    private router: Router
  ) {}

  public async redirectTo(
    path: string[],
    query?: { [key: string]: string },
    fragment?: string
  ): Promise<UrlTree | false> {
    if (isPlatformBrowser(this.platformId)) return this.router.createUrlTree(path, { queryParams: query, fragment });

    let queryString = '';
    if (query) {
      queryString += '?';
      Object.entries(query).forEach(([key, value]) => {
        queryString += `${key}=${value}&`;
      });
      queryString = queryString.substring(0, queryString.length - 1);
    }

    this.response.redirect('/' + path.join('/') + queryString);
    return false;
  }

  public externalRedirectTo(url: string) {
    if (isPlatformBrowser(this.platformId)) {
      window.location.href = url;
    } else {
      this.response.redirect(url);
    }
    return false;
  }
}
